<template>
  <div class="gym-edit-viewer">
    <v-container fluid>
      <gym-viewer
        :items="localValue"
        new-window
      ></gym-viewer>
    </v-container>
  </div>
</template>

<script>
import GymViewer from '@/components/GymViewer/GymViewer';

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },

  components: {
    GymViewer
  },

  computed: {
    localValue: {
      get() {
        return [this.value];
      },

      set(value) {
        this.$emit('input', value);
      }
    }
  }
};
</script>
